// @ts-expect-error Could not find a declaration file for module
import { useSearchParam } from '../../hooks/searchParamHooks';
import { FILTER_TYPES, FILTER_TYPES_OTHER } from '../../constants/TopFilterConstants';
import { useCallback } from 'react';
export const useCatalogSearchParams = () => {
  const [selectedLanguages] = useSearchParam(FILTER_TYPES.LANGUAGE);
  const [searchQuery = ''] = useSearchParam(FILTER_TYPES_OTHER.SEARCH);
  const [selectedCategories] = useSearchParam(FILTER_TYPES_OTHER.CATEGORIES);
  const [selectedDurations] = useSearchParam(FILTER_TYPES.DURATION);
  const [selectedTools] = useSearchParam(FILTER_TYPES_OTHER.TOOLS);
  const [selectedLevels] = useSearchParam(FILTER_TYPES.LEVEL);
  const [selectedContentTypes] = useSearchParam(FILTER_TYPES.CONTENT_TYPE);
  const [selectedAwardTypes] = useSearchParam(FILTER_TYPES.AWARD_TYPE);
  const [selectedSortBys] = useSearchParam(FILTER_TYPES.SORT_BY);
  const [[pageNumber], setPageNumber] = useSearchParam('page');
  const [[progressStatus]] = useSearchParam(FILTER_TYPES.PROGRESS_STATUS);
  const clearPageNumber = useCallback(() => {
    //@ts-expect-error no number
    setPageNumber();
  }, [setPageNumber]);
  return {
    selectedLanguages,
    searchQuery,
    selectedCategories,
    selectedDurations,
    selectedTools,
    selectedLevels,
    selectedContentTypes,
    selectedAwardTypes,
    selectedSortBys,
    pageNumber: Number(pageNumber || 1),
    progressStatus,
    setPageNumber,
    clearPageNumber
  };
};